export default "__VITE_ASSET__b6cfaa7e__"